<script lang="ts">
/*
Entry screen- to make an entry- food ate, sleep, exercise, mood, etc
*/

import type CategoryData from '@/ts/DataTypes/CategoryData';
import Data from '@/ts/Data';
import { defineComponent } from 'vue'
import Category from './Category.vue';

import StaticVars from '@/ts/StaticVars';
import Entry, { EntryDB } from '@/ts/DataTypes/Entry';
import { db, UserDB} from '../ts/DexieDB';
import InputTextSmartVue from './InputTextSmart.vue';
import ButtonVue from './Button.vue';
import EntryEditable from './EntryEditable.vue';

export default defineComponent({
    components: { InputTextSmartVue, ButtonVue, EntryEditable },
    props: {
        //have to have this as a variable in the router/index.ts to actually get it: /:category
        //and can't share data- only strings between components if using vue router

        // SwitchScreen: { type: Function, required:true},
        BackButtonRegister: { type: Function, required:true },
        MoveForwardToPage: { type: Function, required:true },
        MoveBack: { type: Function, required:true },
        


        category: { type: String },
        extra: { type: Object, default: {} },
        // user:{type:UserDB, required:true},
        AddEntry: { type: Function, required:true},
        ShowModal:{ type:Function, required:true},//have to give it a default value, or typescript thinks it could be undefined...,
        GetPrevEntriesForCat:{ type:Function, required:true},
        GetPrevAttributesForCat:{ type:Function, required:true},
        cats:{ type:Array<CategoryData>, required:true},

        DeleteEntryClicked:{ type:Function, required:true},
        AttributeCreateUpdateOrDelete:{ type:Function, required:true},

    },
    data() 
    {
        return {
          entry:(new Entry({blank:true})),
          extra_info:({}),
          loaded:false,

        };
    },
    mounted() 
    {
        

        (this.extra_info as any).entry = this.entry;
        console.log("entry screen mounted ! extra:", this.extra);
       this.loaded=true;
    },
    computed: 
    {
        PrevEntries()
        {
            // let cat = Data.GetCategoryById(this.extra.id) as CategoryData;
            // console.log("PrevEntries: ", cat.entries);
            // // this.refresh_key;//if this changes, vue will realize it, and actually re-compute
            // return [...cat.entries];
        }
    },
    methods: 
    {
        
        //based off of 'EditSubmitted' from EntryEl
        async SubmitNewEntry(extra_info:any)
        {
            console.log("Entry SUbmitted: ", extra_info);
            await Data.AddEntry(extra_info.entry);
        },

        //for entry editable to re-register the back button after the cat edit screen has been closed
        ReRegisterBackBtn()
        {
            (this.$refs.entry_editable as typeof EntryEditable).ReRegisterBackBtn()
        },
        
        //for when a cat gets updated/ added through catedit- need to update the cats here, in the sub compnent entryel->entry editable
        //from entry list
        // async UpdateCatsAfterAddOrUpdate(cat_updated:CategoryData)
        // {
        // }
        
    },
    watch : 
  {
    extra:function(extra_info_new) 
    {
        
        console.log("EntryInputScreen extra_info changed", extra_info_new);

        //check if editcat screen changed a cat, and refresh if so
        if(extra_info_new.cat_changed)
        {
            console.log("EntryInputScreen extra_info_new.cat_changed", extra_info_new.cat_changed, "WARNING- goign to modify extra info!!");
            (this.extra_info as any).cat_changed = true;
            (this.extra_info as any).cat = extra_info_new.cat;
            this.extra_info = {...this.extra_info};
        }
    },  
  },
    
});
</script>

<template>

    <div class="container" v-if="loaded">
        
        <EntryEditable :entry=entry :is_new_entry="true" 

        ref="entry_editable"
        
        
        :ShowModal="ShowModal" 
        :AddOrEditEntry="AddEntry" 
        :extra_info="extra_info"
        :GetPrevEntriesForCat="GetPrevEntriesForCat"
        :GetPrevAttributesForCat="GetPrevAttributesForCat"
        :cats="cats"
        :DeleteEntryClicked="DeleteEntryClicked"

        :BackButtonRegister="BackButtonRegister"
        :MoveForwardToPage="MoveForwardToPage"
        :MoveBack="MoveBack"
        :is_new_screen="true"
        
        :AttributeCreateUpdateOrDelete="AttributeCreateUpdateOrDelete"
        />

    </div>
</template>

<style scoped>
.container
{
    display: flex;
    width:100%;
    gap:10px;
    flex-direction: column;
    margin-top:10px;
    /* align-content: flex-start; */
}
.btn
{
    align-self: flex-start;
    height:.5in;
    /* flex-basis:20%; */
    margin:0;
    width:100%;
}
/* .btn:first-of-type
{
    flex-basis:10%;
} */
.smart_input
{
    flex-grow: 1;
}
</style>